import { Link } from "react-router-dom";
import { HeartPulse } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-navy py-14 text-slate-300" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-10 px-6 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10 text-white">
              <HeartPulse size={18} />
            </span>
            <p className="font-display text-base font-bold text-white">Vitalis <span className="text-sky-400">Digital Store</span></p>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
            Produits digitaux médicaux et informatiques pour les professionnels de santé d'Afrique francophone.
          </p>
        </div>
        <div className="text-sm">
          <p className="mb-4 font-mono text-xs uppercase tracking-widest text-slate-500">Boutique</p>
          <div className="flex flex-col gap-2 text-slate-400">
            <Link to="/catalogue" className="transition-colors duration-200 hover:text-sky-400">Catalogue</Link>
            <Link to="/suivi" className="transition-colors duration-200 hover:text-sky-400">Suivre une commande</Link>
            <Link to="/auth" className="transition-colors duration-200 hover:text-sky-400">Créer un compte</Link>
            <Link to="/compte" className="transition-colors duration-200 hover:text-sky-400">Espace client</Link>
          </div>
        </div>
        <div className="text-sm">
          <p className="mb-4 font-mono text-xs uppercase tracking-widest text-slate-500">Paiements acceptés</p>
          <p className="text-slate-400">Orange Money · MTN MoMo · Wave</p>
          <p className="mt-1 text-slate-400">Carte bancaire (Visa, Mastercard)</p>
          <p className="mt-6 font-mono text-xs text-slate-500">© 2026 Vitalis Digital Store — Tous droits réservés</p>
        </div>
      </div>
    </footer>
  );
}
